module.exports = __webpack_public_path__ + "img/help35.a3880aa5.png";